import React, { useState } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { ProblemSection } from '../components/ProblemSection';
import { BlueprintSection } from '../components/BlueprintSection';
import { CaseStudySection } from '../components/CaseStudySection';
import { SprintPlanSection } from '../components/SprintPlanSection';
import { BonusSection } from '../components/BonusSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
import { RecentPurchaseToast } from '../components/RecentPurchaseToast';
import { ExitUpsellPopup } from '../components/ExitUpsellPopup';
export function SalesPage() {
  const [bump1, setBump1] = useState(false);
  const [bump2, setBump2] = useState(false);
  const [showUpsell, setShowUpsell] = useState(false);
  const basePrice = 27;
  const bumpPrice = 9;
  const totalPrice = basePrice + (bump1 ? bumpPrice : 0) + (bump2 ? bumpPrice : 0);
  const originalPrice = 638 + (bump1 ? 97 : 0) + (bump2 ? 97 : 0);
  // Shopify cart permalinks per selection
  const getCartUrl = () => {
    if (bump1 && bump2) return 'https://coresolutionsg.com/cart/47540986446011:1';
    if (bump1) return 'https://coresolutionsg.com/cart/47540983824571:1';
    if (bump2) return 'https://coresolutionsg.com/cart/47540992966843:1';
    return 'https://coresolutionsg.com/cart/47508774125755:1';
  };
  const handlePurchaseClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    // Intercept checkout if NO bumps are selected
    if (!bump1 && !bump2) {
      e.preventDefault();
      setShowUpsell(true);
      return;
    }
    // Proceed normally if bumps are selected
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The $10K AI Content Engine' + (bump1 ? ' + Template Library' : '') + (bump2 ? ' + Retainer Agreement' : ''),
        content_type: 'product',
        value: totalPrice,
        currency: 'USD'
      });
    }
  };
  const handleAcceptUpsell = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The $10K AI Content Engine + Template Library + Retainer Agreement',
        content_type: 'product',
        value: 31.5,
        currency: 'USD'
      });
    }
    window.open('https://coresolutionsg.com/cart/47541550973115:1', '_blank');
    setShowUpsell(false);
  };
  const handleDeclineUpsell = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'The $10K AI Content Engine',
        content_type: 'product',
        value: 27,
        currency: 'USD'
      });
    }
    window.open('https://coresolutionsg.com/cart/47508774125755:1', '_blank');
    setShowUpsell(false);
  };
  return <div className="min-h-screen bg-dark-950 text-gray-300 font-sans selection:bg-cyan-500/30 selection:text-cyan-200" data-id="element-689">
      <main data-id="element-690">
        <HeroSection data-id="element-691" />
        <StorySection data-id="element-692" />
        <ProblemSection data-id="element-693" />
        <BlueprintSection data-id="element-694" />
        <CaseStudySection data-id="element-695" />
        <SprintPlanSection data-id="element-696" />
        <BonusSection totalPrice={totalPrice} originalPrice={originalPrice} cartUrl={getCartUrl()} onPurchaseClick={handlePurchaseClick} data-id="element-697" />
        <CTASection bump1={bump1} setBump1={setBump1} bump2={bump2} setBump2={setBump2} totalPrice={totalPrice} originalPrice={originalPrice} getCartUrl={getCartUrl} handlePurchaseClick={handlePurchaseClick} data-id="element-698" />
        <Footer data-id="element-699" />
      </main>

      {/* Social Proof Toast System */}
      <RecentPurchaseToast data-id="element-700" />

      {/* Exit Intent Upsell Popup */}
      <ExitUpsellPopup isOpen={showUpsell} onAccept={handleAcceptUpsell} onDecline={handleDeclineUpsell} onClose={() => setShowUpsell(false)} data-id="element-701" />
    </div>;
}